module.exports = __webpack_public_path__ + "img/title.64d55612.png";